"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = processRemove;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _defs = _interopRequireDefault(require("../../_core/defs"));

var _foreach = _interopRequireDefault(require("../../_helpers/foreach"));

// this function removes DOM nodes of removed items
// called on splice, pull, pop and shift
function processRemove(_ref) {
  var selfDef = _ref.selfDef,
      eventOptions = _ref.eventOptions,
      container = _ref.container;
  var removed = eventOptions.removed;
  var selfId = selfDef.id;
  (0, _foreach["default"])(removed, function (item) {
    if (item && (0, _typeof2["default"])(item) === 'object') {
      var itemDef = _defs["default"].get(item);

      if (itemDef) {
        var renderedInArrays = itemDef.renderedInArrays;
        var node = renderedInArrays && renderedInArrays[selfId];

        if (node) {
          delete renderedInArrays[selfId];
          container.removeChild(node);
        }
      }
    }
  });
}
//# sourceMappingURL=processremove.js.map